// Module
var code = "<div class=\"dms-form-wrapper dms-outer-element\">\n    <div class=\"dms-grid-wrapper dms-form #:data.GridName#\">\n    </div>\n</div>";
// Exports
export default code;